import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

function OptionCard({ label, description, selected, onSelect }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={
        `w-full text-left rounded-lg border px-4 py-4 transition ` +
        (selected
          ? 'border-primary bg-blue-50 dark:bg-darkSecondaryBackground'
          : 'border-gray-200 bg-white hover:bg-gray-50 dark:border-gray-800 dark:bg-black dark:hover:bg-darkSecondaryBackground')
      }
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-base font-semibold text-gray-900 dark:text-white">{label}</div>
          <div className="mt-1 text-sm text-gray-600 dark:text-gray-300">{description}</div>
        </div>
        <div
          className={
            `mt-1 h-5 w-5 rounded-full border flex items-center justify-center ` +
            (selected ? 'border-primary' : 'border-gray-300 dark:border-gray-600')
          }
          aria-hidden="true"
        >
          {selected ? <div className="h-3 w-3 rounded-full bg-primary" /> : null}
        </div>
      </div>
    </button>
  );
}

export default function AppearanceSettings() {
  const navigate = useNavigate();
  const { mode, resolvedTheme, setMode } = useTheme();

  return (
    <div className="tailwind fixed inset-0 z-[1000] flex flex-col bg-white dark:bg-black">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-200 dark:border-gray-800">
        <button
          type="button"
          aria-label="Back"
          onClick={() => navigate(-1)}
          className="inline-flex items-center justify-center rounded-md p-2 hover:bg-gray-100 dark:hover:bg-darkSecondaryBackground"
        >
          <ChevronLeft className="h-7 w-7 text-gray-900 dark:text-white" />
        </button>
        <div className="flex flex-col">
          <div className="text-lg font-semibold text-gray-900 dark:text-white">Appearance</div>
          <div className="text-xs text-gray-600 dark:text-gray-400">
            Default: System • Current: {resolvedTheme === 'dark' ? 'Dark' : 'Light'}
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-4">
        <div className="max-w-xl mx-auto space-y-3">
          <OptionCard
            label="System"
            description="Match your device settings"
            selected={mode === 'system'}
            onSelect={() => setMode('system')}
          />
          <OptionCard
            label="Light"
            description="Always use light mode"
            selected={mode === 'light'}
            onSelect={() => setMode('light')}
          />
          <OptionCard
            label="Dark"
            description="Always use dark mode"
            selected={mode === 'dark'}
            onSelect={() => setMode('dark')}
          />
        </div>
      </div>
    </div>
  );
}
